import React from 'react';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { hideToast } from 'store/toastSlice';
import Toast from './toast';

const GlobalToast: React.FC = () => {
  const dispatch = useAppDispatch();
  const { isVisible, text, position, duration, id, type } = useAppSelector((state) => state.toast);

  if (!isVisible) return null;

  const getIcon = () => {
    switch (type) {
      case 'success':
        return (
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="#fff"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
            width="18"
            height="18"
          >
            <polyline points="20 6 9 17 4 12"></polyline>
          </svg>
        );
      case 'error':
        return (
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="#fff"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
            width="18"
            height="18"
          >
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        );
      case 'info':
      default:
        return (
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="#fff"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
            width="18"
            height="18"
          >
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" y1="16" x2="12" y2="12"></line>
            <line x1="12" y1="8" x2="12.01" y2="8"></line>
          </svg>
        );
    }
  };

  return (
    <Toast
      key={id}
      text={text}
      type={type}
      position={position}
      duration={duration}
      id={id}
      onClose={() => dispatch(hideToast())}
      icon={getIcon()}
    />
  );
};

export default GlobalToast;
